<template>
  <div>
    <!-- Thông báo -->
    <transition name="slide-up-fade">
      <div v-if="show" class="notification">
        <div>
          <b>Đang tải xuống...</b>
          <div class="shell" v-if="sseData >= 0">
            <div class="bar" :style="{ width: sseData + '%' }">
              <div class="spanSse" v-if="sseData >= 5">{{ sseData }}%</div>
            </div>
          </div>
        </div>
        <button @click="closeNotification" class="close-button">&times;</button>
      </div>
    </transition>

    <!-- Biểu tượng để mở lại thông báo -->
    <transition name="slide-up-fade">
      <div v-if="showIcon" @click="showNotification" class="icon">
        <i class="bx bx-arrow-to-bottom icon-animation"></i>
      </div>
    </transition>
  </div>
</template>

<script>
  import { CommonService } from '../services/common.service'
  import { getUrl } from '../services/customer-support'
  export default {
    data() {
      return {
        show: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        token: localStorage.getItem('token'),
        sseData: 0,
        showIcon: false,
      }
    },
    methods: {
      triggerNotification(id) {
        this.readFile(id)
      },
      showNotification() {
        this.show = true
        this.showIcon = false
      },
      closeNotification() {
        this.show = false
        this.showIcon = true
      },
      async readFile(id) {
        const url = getUrl('cnps.summary.file.export.download-file')
        try {
          const sseClient = await fetch(
            // `https://cnps.vn00.vn.fastgo.cloud:9817/file/export/download-file?id=${id}`,
            `${url}?id=${id}`,
            {
              headers: {
                Authorization:
                  this.dataUser && this.dataUser.token ? this.dataUser.token : this.token,
              },
            }
          )
          if (!sseClient.ok) {
            throw Error(sseClient.statusText())
          }
          this.showNotification()

          for (const reader = sseClient.body.getReader(); ; ) {
            const { value, done } = await reader.read()
            if (done) {
              break
            }
            const chunk = new TextDecoder().decode(value)
            const payload = chunk.replace(/^data:/, '')
            if (payload.includes('PATH_FILE_S3')) {
              const parts = payload.split(' ')
              const url = parts[parts.length - 1]
              this.downloadFile(url, id)
              this.sseData = -1
            } else this.sseData = Number(payload)
          }
        } catch (error) {
          console.log(error)
        }
      },
      downloadFile(url, id) {
        window.open(url, '_blank')
        this.closeNotification()
        this.maskReadFile(id)
        this.showIcon = false
      },
      async maskReadFile(id) {
        await CommonService.maskReadFile({ id })
      },
    },
  }
</script>

<style scoped>
  .slide-up-fade-enter-active,
  .slide-up-fade-leave-active {
    transition: all 0.5s ease;
  }
  .slide-up-fade-enter,
  .slide-up-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }
  @keyframes icon-bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }

  .icon-animation {
    animation: icon-bounce 2s infinite;
    position: absolute;
    top: 10px;
  }

  .icon {
    height: 40px;
    width: 40px;
    position: fixed;
    right: 20px;
    bottom: 25px;
    cursor: pointer;
    font-size: 24px;
    color: #ffffff;
    background-color: #4285f4;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 3px 2px 6px rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .notification {
    position: fixed;
    right: 20px;
    bottom: 20px;
    background-color: #ffffff;
    color: #333333;
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.4);
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 300px;
    border-top: 5px solid #4285f4;
    border-right: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }

  .close-button {
    background: none;
    border: none;
    color: #4285f4;
    font-size: 1.5rem;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 5px;
  }
  .shell {
    height: 18px;
    width: 230px;
    border: 1px solid #aaa;
    border-radius: 13px;
    padding: 3px;
  }

  .bar {
    background: linear-gradient(to right, #b993d6, #8ca6db);
    height: 10px;
    width: 15px;
    border-radius: 9px;
  }
  .spanSse {
    float: right;
    padding: 0px 5px;
    color: #fff;
    font-size: 9px;
  }
</style>
